import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, Modal, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import brokerGroupApi from "../../../api/brokerGroupApi";
import { ContextNotification, severitys } from "../../../App";
import ConfirmFlight from "../FlightPanel/ConfirmFlight";
import { ContextUserInfo } from "../../../Layout/MainLayout";
import AccessControl from "../../../Components/AccessControl";
import RtlProvider from "../../../Components/RtlProvider";
import AddPassengerToFlight from "./AddPassengerToFlight";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import customtheme from "../../../themes";


const ConfirmFlightPassenger = ({ row, handleNextStep }) => {

    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { setOpen } = useContext(ContextNotification);
    const [openedGroupKey, setOpenedGroupKey] = useState(null);
    const [groupsData, setGroupsData] = useState([]);
    const [selectedItemsPassenger, setSelectedItemsPassenger] = useState([]);
    const [selectedItemsGroups, setSelectedItemsGroups] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const customization = useSelector((state) => state.customization);

    const schema = yup.object().shape({

    });
    const { register, handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
        resolver: yupResolver(schema),
    });

    const ResetForm = () => {
        setOpenedGroupKey(null);
        setSubmitLoading(false);
        setSelectedItemsPassenger([]);
        setSelectedItemsGroups([]);
        setFilterPassengerName(null);
        setFilterSSn(null);
        GetGroupsData();


    }
    const GetGroupsData = () => {
        brokerGroupApi.GetFlightGroupsAndPassengers(row.flightId)
            .then((res) => {
                setGroupsData(res.data.data);
                const peresentPassInGrp = [];
                res.data.data.flightGroupMembersResponses?.map((itm) => {
                    return itm.tripPassengerMembersResponses.map((pass) => {
                        if (((pass.flightAttendanceStatus === null) || (pass.flightAttendanceStatus === true)))
                            peresentPassInGrp.push(pass.passengerId);
                    })
                });
                const peresentPassOther =[];
                 res.data.data.flightPassengerMembersResponses?.filter(itm => ((itm.flightAttendanceStatus === null) || (itm.flightAttendanceStatus === true)))
                .map((pass) => {
                        if (((pass.flightAttendanceStatus === null) || (pass.flightAttendanceStatus === true)))
                           peresentPassOther.push(pass.passengerId);
                    })
                if (peresentPassOther.length>0)
                    peresentPassInGrp.push(...peresentPassOther);

                setSelectedItemsPassenger(peresentPassInGrp);
            }
            )
            .catch((error) => console.log(error));
    }


    useEffect(() => {
        ResetForm();
    }, [row]);

    const handleCheckboxPassengerChange = (item, groupid) => {
        if ((groupid!==null)&&(selectedItemsGroups.includes(groupid)) && (selectedItemsPassenger.includes(item)))
            setSelectedItemsGroups([...selectedItemsGroups.filter((i) => i !== groupid)]);
        setSelectedItemsPassenger((prev) =>
            prev.includes(item)
                ? prev.filter((i) => i !== item) // Remove if already selected
                : [...prev, item] // Add if not selected
        );
    };
    const handleCheckboxGroupChange = (groupid) => {
        var passengers = groupsData.flightGroupMembersResponses.find((itm) => itm.brokergroupId === groupid)?.tripPassengerMembersResponses?.map((pass) => { return pass.passengerId });
        if (selectedItemsGroups.includes(groupid)) {
            setSelectedItemsGroups([...selectedItemsGroups.filter((i) => i !== groupid)])
            setSelectedItemsPassenger([...selectedItemsPassenger.filter((i) => !passengers.includes(i))]);
        }
        else {
            setSelectedItemsGroups([...selectedItemsGroups, groupid]);
            setSelectedItemsPassenger([...selectedItemsPassenger.filter((i) => !passengers.includes(i)), ...passengers]);
        }

    };


    const SavePassengers = () => {
        var passengerInGroup = [];
        var otherpass = [];

        passengerInGroup = groupsData.flightGroupMembersResponses.filter(tg => tg.brokerCode !== null).filter((p) => (p.tripPassengerMembersResponses.some(a =>
            !selectedItemsPassenger.includes(a.passengerId))))?.map((t) => {
                return {
                    brokerGroupId: t.brokergroupId,
                    deleteAll: false,
                    tripPassengerMembersResponses: t.tripPassengerMembersResponses.filter(r => !selectedItemsPassenger.includes(r.passengerId))?.map(tr => { return tr.passengerId })
                };
            })
        groupsData.flightPassengerMembersResponses.map((p) => {
                if (!(selectedItemsPassenger.includes(p.passengerId)))
                    otherpass.push(p.passengerId)
            });
            
        var cancelData = {
            "flightId": row.flightId,
            "passengerInGroup": passengerInGroup,
            "othersPassengers": otherpass
        }
        brokerGroupApi.CancelForTripAndMembers(cancelData).then(res => {
            if (res.status === 200) {
                setOpen({ IsEnable: true, Message: 'تغییرات با موفقیت ثبت شد', severity: severitys.success });
                ResetForm();
                handleNextStep();
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {
            if (err.status === 401) {
                localStorage.clear();
                window.location.pathname = "/login";
            }
            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        })
    }


    const [filterPassengerName, setFilterPassengerName] = useState(null);
    const [filterSSn, setFilterSSn] = useState(null);
    const handleFilterPassenger = (event) => {
        var fullname = event.target.value;
        if (!(fullname) || (fullname.trim() === ''))
            setFilterPassengerName(null)
        else if (Number(fullname.trim())) {
            setFilterSSn(fullname.trim())
            setFilterPassengerName(null);
        }
        else {
            setFilterSSn(null);
            setFilterPassengerName(fullname.trim());

        }
    }


    return (
        <div>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    {/* <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
              تایید پرواز
            </Typography> */}
                    <form onSubmit={handleSubmit(SavePassengers)}>


                        <Grid container spacing={1} >

                            <Grid item md={12} xs={12}>
                                <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }} sx={{ mt: 1, ml: 2 }}>
                                    {'افراد حاضر در پرواز را انتخاب نمائید:'}
                                </Typography>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                {groupsData.flightGroupMembersResponses?.map((tripGroupMember, index) => {
                                    return (
                                        <Box sx={{ p: 1 }}>

                                            <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
                                                <Tooltip title=" مشاهده لیست مسافران کاروان" placement="top">
                                                    <IconButton onClick={() => {
                                                        setFilterPassengerName(null);
                                                        setFilterSSn(null);
                                                        setOpenedGroupKey(openedGroupKey === (index + 1) ? null : index + 1);
                                                    }}>
                                                        {((openedGroupKey) && (openedGroupKey === index + 1)) ? (
                                                            <FaChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />


                                                        ) : (
                                                            <FaChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                                                        )
                                                        }
                                                    </IconButton>

                                                </Tooltip>
                                                {( tripGroupMember.brokerCode + ' - ' + tripGroupMember.groupNo + ' - ' + tripGroupMember.brokerName )
                                                    + ' ( ' + ((row.flightDateReal !== null) ? String(tripGroupMember.tripPassengerMembersResponses ? tripGroupMember.tripPassengerMembersResponses.filter(pass => ((pass.flightAttendanceStatus === null) || (pass.flightAttendanceStatus === true))).length : 0)
                                                        : String(tripGroupMember.tripPassengerMembersResponses ? tripGroupMember.tripPassengerMembersResponses.length : 0)) + ' )'}

                                                {AccessControl.checkPermissions(userPermissions, ["Flight:CancelForFlightAndMembers"]) && <Tooltip title="انتخاب همه" placement="left">
                                                    <Checkbox
                                                        key={tripGroupMember.brokergroupId}
                                                        checked={(selectedItemsGroups?.includes(tripGroupMember.brokergroupId))}
                                                        onChange={() => handleCheckboxGroupChange(tripGroupMember.brokergroupId)}
                                                    >
                                                    </Checkbox>
                                                </Tooltip>
                                                }
                                            </Typography>

                                            {((openedGroupKey) && (openedGroupKey === index + 1)) &&
                                                <div>
                                                    <Grid container spacing={1}>

                                                        <Grid item md={6.5} xs={7.5}>
                                                            <Typography variant="h6" gutterBottom component="div" style={{ textAlign: "right" }}>
                                                                <TextField variant="outlined" label=" جستجوی نام/کدملی زائر" sx={{ mt: 1, ml: 2, mb: 1 }} onChange={handleFilterPassenger}>
                                                                </TextField></Typography>
                                                        </Grid>
                                                    </Grid>
                                                     <Box sx={{
                                                                                        p:2,
                                                                                        ml:2,
                                                                                        mt: 1,
                                                                                        mb: 1,
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        maxHeight: 300,
                                                                                        overflowY: "scroll",
                                                                                    }} >
                                                    <table border={1} cellSpacing={0} cellPadding={1} style={{ textAlign: "center" }}>
                                                        <thead style={{ backgroundColor: 'rgba(233, 245, 202, 0.9)' }}>
                                                            <th> کد ملی</th>
                                                            <th> نام و نام خانوادگی</th>
                                                            <th>تایید حضور</th>

                                                        </thead>
                                                        <tbody>

                                                            {tripGroupMember.tripPassengerMembersResponses?.filter(pass => (((!filterPassengerName) && (!filterSSn)) || (pass.fullName.includes(filterPassengerName) || pass.sSn.includes(filterSSn)))).map((Passenger) => (
                                                                <tr>
                                                                    <td>{Passenger.sSn}</td>
                                                                    <td>{Passenger.fullName}</td>

<td>
                                                                        <Box sx={{ p: 1 }}>

                                                                            <Tooltip title="تایید حضور" placement="left">
                                                                                <Checkbox
                                                                                    key={Passenger.passengerId}
                                                                                    checked={(selectedItemsPassenger?.includes(Passenger.passengerId))}
                                                                                    onChange={() => handleCheckboxPassengerChange(Passenger.passengerId, tripGroupMember.brokergroupId)}
                                                                                >
                                                                                </Checkbox>
                                                                            </Tooltip>


                                                                        </Box>
                                                 </td>

                                                                </tr>
                                                            ))
                                                            }

                                                        </tbody>
                                                    </table>
                                                    </Box>
                                                </div>
                                            }
                                        </Box>
                                    );
                                }
                                )}
                                {
                                   (groupsData.flightPassengerMembersResponses?.length>0)&&<Box sx={{m:2}}>
                                     <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
                                                <Tooltip title=" مشاهده لیست مسافران کاروان" placement="top">
                                                    <IconButton onClick={() => {
                                                        setFilterPassengerName(null);
                                                        setFilterSSn(null);
                                                        setOpenedGroupKey(openedGroupKey === -100 ? null : -100);
                                                    }}>
                                                        {((openedGroupKey) && (openedGroupKey === -100)) ? (
                                                            <FaChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />


                                                        ) : (
                                                            <FaChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                                                        )
                                                        }
                                                    </IconButton>

                                                </Tooltip>
                                                {'لیست مسافران آزاد'}
                                                </Typography>
                                         {((openedGroupKey) && (openedGroupKey === -100)) &&
                                                <div>
                                                    <Grid container spacing={1}>

                                                        <Grid item md={6.5} xs={7.5}>
                                                            <Typography variant="h6" gutterBottom component="div" style={{ textAlign: "right" }}>
                                                                <TextField variant="outlined" label=" جستجوی نام/کدملی زائر" sx={{ mt: 1, ml: 2, mb: 1 }} onChange={handleFilterPassenger}>
                                                                </TextField></Typography>
                                                        </Grid>
                                                    </Grid>
                                                     <Box sx={{
                                                                                        p:2,
                                                                                        ml:2,
                                                                                        mt: 1,
                                                                                        mb: 1,
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        maxHeight: 300,
                                                                                        overflowY: "scroll",
                                                                                    }} >
                                                    <table border={1} cellSpacing={0} cellPadding={1} style={{ textAlign: "center" }}>
                                                        <thead style={{ backgroundColor: 'rgba(233, 245, 202, 0.9)' }}>
                                                            <th> کد ملی</th>
                                                            <th> نام و نام خانوادگی</th>
                                                            <th>نوع مسافر</th>
                                                            <th>تایید حضور</th>

                                                        </thead>
                                                        <tbody>

                                                            {groupsData.flightPassengerMembersResponses?.filter(pass => (((!filterPassengerName) && (!filterSSn)) || (pass.fullName.includes(filterPassengerName) || pass.sSn.includes(filterSSn)))).map((Passenger) => (
                                                                <tr>
                                                                    <td>{Passenger.sSn}</td>
                                                                    <td>{Passenger.fullName}</td>
                                                                    <td>{Passenger.brokerTypeTitle}</td>

<td>
                                                                        <Box sx={{ p: 1 }}>

                                                                            <Tooltip title="تایید حضور" placement="left">
                                                                                <Checkbox
                                                                                    key={Passenger.passengerId}
                                                                                    checked={(selectedItemsPassenger?.includes(Passenger.passengerId))}
                                                                                    onChange={() => handleCheckboxPassengerChange(Passenger.passengerId, null)}
                                                                                >
                                                                                </Checkbox>
                                                                            </Tooltip>


                                                                        </Box>
                                                 </td>

                                                                </tr>
                                                            ))
                                                            }

                                                        </tbody>
                                                    </table>
                                                    </Box>
                                                </div>
                                            }
                                    </Box>
                                }
                            </Grid>
                            <Grid container  md={12} xs={12} >
                                <Grid item md={9} xs={6}></Grid>
                                <Grid item md={3} xs={6}>
                                    <Button type="submit" sx={{width: 150, m: 2 }} disabled={submitLoading} variant="contained" color="primary"
                                    ><BeatLoading loading={submitLoading} color={"#e65100"} />
                                        {'ثبت حضور زائران'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </div>
    )
}
export default ConfirmFlightPassenger;